export enum ExpireBannerType {
    BANK = 'BANK',
    CARD = 'CARD',
    INVEST = 'INVEST',
    PFMS = 'PFMS',
    INSU = 'INSU',
    PENSION = 'PENSION',
    LOAN = 'LOAN',
    MANAGEMENT = 'MANAGEMENT',
    EFIN = 'EFIN',
}

export enum ExpireBannerEdgeType {
    NONE = 'none',
    LEFT = 'left',
    RIGHT = 'right',
}

export enum ExpireIndustry {
    BANK = 'bank',
    CARD = 'card',
    INVEST = 'invest',
    INSU = 'insu',
    PENSION = 'pension',
    LOAN = 'loan',
    TELECOM = 'telecom',
    EFIN = 'efin',
}
